import { BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const NoteActions = styled.div`
	position: absolute;
	right: 10px;
	bottom: -16px;
	display: none;
	box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
	height: 32px;
	width: 88px;
	background-color: rgba(22, 27, 38, 1);
	border: 1px solid rgba(51, 55, 65, 1);
	border-radius: ${BorderRadius.MD}px;
	z-index: 2;

	&:hover {
		display: block;
	}
`;

const NoteItem = styled.div`
	position: relative;
	width: 100%;

	&:hover ${NoteActions} {
		display: block;
	}
`;

const NoteActionButton = styled.button`
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;

	&:hover {
		#copy,
		#trash {
			path {
				stroke: rgba(255, 255, 255, 1) !important;
			}
		}

		#small-pencil {
			path {
				fill: rgba(255, 255, 255, 1) !important;
			}
		}
	}
`;

const FieldText = styled.div`
	width: 100%;
	padding: 9px 13px;
	background-color: #fff8e6;
	border: 1px solid ${BorderColors.Secondary};
	border-top-right-radius: ${BorderRadius.MD}px;
	border-bottom-right-radius: ${BorderRadius.MD}px;
	border-bottom-left-radius: ${BorderRadius.MD}px;
	display: flex;
`;

export { FieldText, NoteItem, NoteActions, NoteActionButton };
